import React from 'react';
import classes from "./FAQs.module.css";
import { Col, Container, Row } from 'react-bootstrap';
import SectionHeader from '../../components/SectionHeader';
import Button from "../../components/Button";
import Accordian from '../../components/Accordian';
import { AccordianData } from '../../data/app-data';

export default function FAQs() {
    const handleScroll = (id) => {
        const section = document.getElementById(id);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      };
    return (
        <Container>
            <Row className={`my-5 py-5 gy-3`}>
                <Col lg={5}>
                    <SectionHeader title={"FAQs"} heading={`Got Any Question? We’ve got Answers.`} className={classes.headingClass} />
                    <p className="f-16 -f-400 mt-2">{`We offer tailored consulting solutions to help your business grow, solve challenges, and achieve lasting success with expert guidance and measurable results.`}</p>
                    <Row className='mt-4 gy-3'>
                        <Col md={5} className='mx-1'>
                            <Button label={"Get Started"} variant={"gradient"} className={classes.btnClass} />
                        </Col>
                        <Col md={5} className='mx-1'>
                            <Button label={"contact us"} variant={"outlined"} onClick={() => handleScroll("contact")} />
                        </Col>
                    </Row>
                </Col>
                <Col lg={7}>
                    {AccordianData?.map((e, i) => {
                        return (
                            <Accordian key={i} title={e?.title}>
                                <p className="f-16 fw-400">{e?.content}</p>
                            </Accordian>
                        )
                    })}
                </Col>
            </Row>
        </Container>
    )
}
